module.exports = __webpack_public_path__ + "assets/topup.c0c13417.svg";